import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";

import { RequireUser } from "./auth/RequireUser";
import { CostTreePage } from "./features/cost-tree/CostTreePage";
import { ResourcePage } from "./features/resources/ResourcePage";
import { UnassignedResourcesPage } from "./features/resources/UnassignedResourcesPage";
import { StatusPage } from "./features/status/StatusPage";
import "./i18n/i18n";
import { AppLayout } from "./layout/AppLayout";

const router = createBrowserRouter([
    {
        element: (
            <RequireUser>
                <AppLayout />
            </RequireUser>
        ),
        children: [
            { index: true, element: <CostTreePage /> },
            { path: "unassigned", element: <UnassignedResourcesPage /> },
            { path: "resources/:cloudResourceId", element: <ResourcePage /> },
            { path: "status", element: <StatusPage /> },
        ],
    },
]);

const theme = createTheme();

const root = document.getElementById("root");
if (root === null) {
    throw new Error("Root element missing");
}
createRoot(root).render(
    <StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <RouterProvider router={router} />
        </ThemeProvider>
    </StrictMode>,
);
